import React from "react";

import { SCENARIO } from "../scenario/torbridge.js";
import { L2_SCHEMAS } from "../data.js";
import { CollapsibleJson } from "./JsonView.js";

// A shared wrapper: a titled card with teaching copy and a set of collapsible
// JSON documents underneath. Every artifact view (schema / template / receipt)
// uses the same shell so they read as one system.
function ArtifactCard({
  title,
  explainer,
  children
}: {
  title: string;
  explainer: string[];
  children: React.ReactNode;
}) {
  return (
    <section className="artifact-card">
      <h3 className="artifact-title">{title}</h3>
      <div className="artifact-explainer">
        {explainer.map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
      <div className="artifact-docs">{children}</div>
    </section>
  );
}

// C. The evidence schemas the L2 receipt validates against.
export function SchemaView() {
  const copy = SCENARIO.copy.schemaView;
  return (
    <ArtifactCard title={copy.title} explainer={copy.explainer}>
      {L2_SCHEMAS.map((s) => (
        <CollapsibleJson key={s.schemaId} title={s.schemaId} subtitle={s.path} json={s.schema} />
      ))}
    </ArtifactCard>
  );
}

// D. The mandate template and its bound parameters (L3 / L3!).
export function TemplateView({
  profileJson,
  paramsJson
}: {
  profileJson?: string;
  paramsJson?: string;
}) {
  const copy = SCENARIO.copy.templateView;
  return (
    <ArtifactCard title={copy.title} explainer={copy.explainer}>
      {profileJson !== undefined && (
        <CollapsibleJson title="profile.json" subtitle="the bound mandate" json={profileJson} />
      )}
      {paramsJson !== undefined && (
        <CollapsibleJson title="params.json" subtitle="the bound parameters" json={paramsJson} />
      )}
    </ArtifactCard>
  );
}

// G. The sealed receipt envelope itself (every layer that has one).
export function ReceiptView({
  receiptJson,
  defaultOpen = false
}: {
  receiptJson: string;
  defaultOpen?: boolean;
}) {
  const copy = SCENARIO.copy.receiptView;
  return (
    <ArtifactCard title={copy.title} explainer={copy.explainer}>
      <CollapsibleJson
        title="receipt.json"
        subtitle="the sealed envelope"
        json={receiptJson}
        defaultOpen={defaultOpen}
      />
    </ArtifactCard>
  );
}
